import { loadStripe } from "@stripe/stripe-js";

import { StripeSupportedCurrency } from "@/pages/PaymentMethods/types";
import { CardTypes, StripeCreditCardBrands } from "@/api/opb/opbTypes";

export function loadStripeWithConfig(currency: StripeSupportedCurrency) {
  const { VITE_STRIPE_KEY_USD, VITE_STRIPE_KEY_GBP, VITE_STRIPE_KEY_CAD } =
    import.meta.env;

  if (currency.toLowerCase() === StripeSupportedCurrency.Gbp) {
    return loadStripe(VITE_STRIPE_KEY_GBP);
  }

  if (currency.toLowerCase() === StripeSupportedCurrency.Cad) {
    return loadStripe(VITE_STRIPE_KEY_CAD);
  }
  // default to USD
  return loadStripe(VITE_STRIPE_KEY_USD);
}

export function getCardBrandFromStripe(
  cardType: StripeCreditCardBrands
): CardTypes | undefined {
  switch (cardType) {
    case StripeCreditCardBrands.Mastercard:
      return CardTypes.Mastercard;
    case StripeCreditCardBrands.Visa:
      return CardTypes.Visa;
    case StripeCreditCardBrands.Amex:
      return CardTypes.Amex;
    case StripeCreditCardBrands.Discover:
      return CardTypes.Discover;
    default:
      return undefined;
  }
}
